<template>
    <v-dialog
        v-model="dialog"
        :max-width="dialog_width"
        :persistent="saveLoading"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
            <h2 class="tw-capitalize tw-text-secondary">
                Edit Trainees Content
            </h2>
            <v-form name="editForm" ref="editForm">
                <div class="mb-2 p-2">
                    <w-y-s-i-w-y-g
                        v-if="activeEditor1"
                        v-model="modelObject.body"
                    />
                </div>
            </v-form>
            <v-form name="editDoc" ref="editDoc">
                <h2 class="tw-capitalize tw-text-secondary my-4">
                    Documents
                </h2>
                <v-container>
                    <smart-table
                        :headers="headers"
                        :items="items"
                        :items-per-page="7"
                        ref="smartTable"
                    >
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>
                                    <v-text-field
                                        v-model="item.title"
                                        label="Title"
                                        outlined
                                        dense
                                        hide-details
                                    />
                                </td>
                                <td>
                                    <v-file-input
                                        v-model="item.new_pdf_name"
                                        outlined
                                        label="PDF"
                                        dense
                                        hide-details
                                    />
                                </td>
                                <td>
                                    <v-file-input
                                        v-model="item.new_image_name"
                                        outlined
                                        label="Image"
                                        dense
                                        hide-details
                                    />
                                </td>
                                <td>
                                    <v-btn @click="uploadItem(item)" class="main-btn"
                                           :disabled="isUploadDisabled(item)">Upload
                                    </v-btn>
                                    <v-btn @click="deleteItem(item)" class="main-btn">Delete</v-btn>
                                </td>
                            </tr>
                        </template>
                    </smart-table>
                    <!-- Button to add new rows -->
                    <v-btn @click="addRow" class="main-btn">Add new Document</v-btn>
                </v-container>


            </v-form>
            <div class="tw-flex tw-flex-row tw-justify-center tw-gap-3">
                <v-btn
                    text
                    @click="cancelDialog"
                    class="main-btn"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    @click="saveModel"
                    class="main-btn"
                    :loading="saveLoading"
                >
                    Save
                </v-btn>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import WYSIWYG from "@/Generic/WYSIWYG";
import SmartTable from "@/Generic/SmartTable";

export default {
    name: "EditTraineesContentModal",
    components: {
        WYSIWYG,
        SmartTable,
    },
    props: {
        'value': {
            // The visibility of the dialog.  To be used with `v-model`
            type: Boolean,
            required: true
        },
        'modelProp': {
            // The model we want to show details for (model is generic and don't require to be modified for each reuse of this modal)
            type: Object,
            required: false
        },
        'refElement': {
            type: String,
            required: false
        },
        'constants': {
            type: Object,
            required: true
        },
        'valuelists': {
            type: Object,
            required: false
        },
    },
    updated() {
        //
    },
    mounted() {
        this.fetchTraineesDocuments();
    },
    data() {
        return {
            dialog: this.value || false,
            mode: '',
            modelObject: structuredClone(this.modelProp) || {}, // Don't want to modify the original model while typing in the editor, clone used.
            modelDefault: {
                id: null,
                body: null,
            },
            saveLoading: false,
            rules: {
                required: value => !!value || 'Required',
            },
            activeEditor1: false,
            headers: [
                {value: 'title', text: 'Title', width: '30%', align: 'center'},
                {value: 'pdf_name', text: 'PDF', width: '25%', align: 'center'},
                {value: 'image_name', text: 'Image', width: '25%', align: 'center'},
                {value: 'action', text: 'Actions', width: '20%', sortable: false, align: 'center'},
            ],
            items: [],
        }
    },
    computed: {
        dialog_width() {
            return '80%'
        },
        // is_edit_mode() {
        //     return this.mode == 'Edit' ? true : false
        // }
    },
    methods: {
        async fetchTraineesDocuments(refreshTable = true) {
            try {
                this.loading = true
                const response = await axios.get("/trainees-documents")
                this.items = response.data.traineesDocuments

                // Refresh the SmartTable if needed
                if (refreshTable) {
                    try {
                        this.$refs.smartTable.refresh()
                    } catch (error) {

                    }
                }
            } catch (error) {
                console.error("Error fetching trainees documents:", error)
            } finally {
                this.loading = false
            }
        },


        isUploadDisabled(item) {
            // Disable for new rows only
            if (!item.id) {
                return (
                    !item.title ||
                    !item.new_pdf_name ||
                    !item.new_image_name
                )
            }
            return false
        },
        addRow() {
            this.items.push({
                title: "",
                pdf: null,
                image: null,
            })
        },
        initEditor() {
            this.$nextTick(() => {
                this.activeEditor1 = true
            })
        },
        resetModel() {
            this.modelObject = structuredClone(this.modelDefault)
        },
        cancelDialog() {
            if (!this.loading) {
                this.dialog = false
            }
        },
        uploadItem(item) {

            if (this.$refs.editDoc.validate()) {
                let formData = new FormData()
                for (let key in item) {
                    if (item[key] !== null && item[key] !== undefined && item[key] !== 'undefined') {
                        formData.append(key, item[key])
                    } else {
                        formData.append(key, '')
                    }
                }

                var url = ''

                if (item.id) {
                    // Existing record, update it
                    url = route('traineesdocuments.update', item.id)
                    formData.append("_method", "put")

                } else {
                    // New record, store it
                    url = route('traineesdocuments.store')
                }

                axios({
                    method: 'post',
                    url: url,
                    data: formData,
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Changes have been saved')
                            this.$root.is_dirty = false
                            this.saveLoading = false
                            this.fetchTraineesDocuments(true)
                        } else if (response.data?.error) {
                            throw (response.data?.error)
                        } else {
                            throw ('Unknown error.')
                        }
                    })
                    .catch((error) => {
                        this.saveLoading = false
                        this.$root.handleErrors(error)
                    })
            } else {
                this.$root.snackbar.error('Please fill all required fields.')
            }
        },

        async deleteItem(item) {
            if (!item.id || await this.$root.confirm.open(`Delete Trainees Document`, `You are about to delete ${item.title}`)) {
                try {
                    if (item.id) {
                        // If item has an ID, it means it's an existing record in the backend
                        const response = await axios.delete(`/traineesdocuments/${item.id}`);
                        if (response.data.success) {
                            this.$root.snackbar.success('Item deleted successfully.');
                            // Remove the item from the local array
                            const index = this.items.indexOf(item);
                            if (index !== -1) {
                                this.items.splice(index, 1);
                            }
                        } else if (response.data.error) {
                            throw response.data.error;
                        } else {
                            throw 'Unknown error.';
                        }
                    } else {
                        // If item doesn't have an ID, it's a new record not yet saved to the backend
                        // Simply remove it from the local array
                        const index = this.items.indexOf(item);
                        if (index !== -1) {
                            this.items.splice(index, 1);
                        }
                    }
                } catch (error) {
                    this.$root.handleErrors(error);
                }
            }
        },

        saveModel() {
            //let payload = this.modelObject

            if (this.$refs.editForm.validate()) {

                this.saveLoading = true
                let formData = new FormData()
                for (let key in this.modelObject) {
                    if (this.modelObject[key] !== null
                        && this.modelObject[key] !== undefined
                        && this.modelObject[key] !== 'undefined'
                    ) { // Adding three as system is not stable with this from time to time
                        formData.append(key, this.modelObject[key])
                    } else {
                        formData.append(key, '');
                    }
                }

                var url = route('content.update', this.modelObject.id)
                formData.append("_method", "put")

                axios({
                    method: 'post',
                    url: url,
                    data: formData,
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Changes have been saved')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.modelObject.body = response.data.content.body
                            this.$inertia.reload({only: ['input']})
                            this.$emit('updatedContent', this.$root.sanitizeAndTruncateHTML(response.data.content.body, 1000), this.refElement)

                            this.saveLoading = false
                        } else if (response.data?.error) {
                            throw (response.data?.error)
                        } else {
                            throw ('Unknown error.')
                        }
                    })
                    .catch((error) => {
                        this.saveLoading = false
                        this.$root.handleErrors(error)
                    })
            } else {
                this.$root.snackbar.error('Please fill all required fields.')
            }
        },
    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput
        },
        dialog(newDialog, oldDialog) {
            this.$emit('input', newDialog)
            if (newDialog === false) {
                // Closing
                this.activeEditor1 = false
            } else {
                // Opening
                this.initEditor()
            }
        },
    },
}
</script>
<style scoped>
</style>
